import React, { useEffect, useState } from 'react'
import '../../assets/css/dairiten.css'
import '../../assets/css/pamphlet.css'
import { CDP_API_URL, CDP_PUBLIC_URL } from '../../utils/Constants'
import { errorMessages } from '../form/FormValidationRules'
import { PamphletPageNumber } from '../../utils/AppText'
import InputScreenErrorMessage from '../InputScreenErrorMessage'
import { useLocation, useNavigate } from 'react-router-dom'
import { headers } from '../../api/CDPAPI'
import axios from 'axios'
const PamphletRequestForm = () => {
    document.title = '資料請求｜法人のお客様｜メットライフ生命'
    const navigate = useNavigate()
    const location = useLocation()
    const confirmData = location.state
    const [data, setData] = useState({})
    const [service, setService] = useState([])
    const [product, setProduct] = useState([])
    const [groupName, setGroupName] = useState('')
    const [groupNameKana, setGroupNameKana] = useState('')
    const [repFirstName, setRepFirstName] = useState('')
    const [repLastName, setRepLastName] = useState('')
    const [repFirstNameKana, setRepFirstNameKana] = useState('')
    const [repLastNameKana, setRepLastNameKana] = useState('')
    const [deptName, setDeptName] = useState('')
    const [userFirstName, setUserFirstName] = useState('')
    const [userLastName, setUserLastName] = useState('')
    const [userFirstNameKana, setUserFirstNameKana] = useState('')
    const [userLastNameKana, setUserLastNameKana] = useState('')
    const [zip1, setZip1] = useState('')
    const [zip2, setZip2] = useState('')
    const [prefecture, setPrefecture] = useState('都道府県')
    const [address1, setAddress1] = useState('')
    const [address2, setAddress2] = useState('')
    const [phone, setPhone] = useState('')
    const [fax, setFax] = useState('')
    const [contact, setContact] = useState('')
    const [email, setEmail] = useState('')
    const [contractStatus, setContractStatus] = useState('')
    const [groupSize, setGroupSize] = useState('')
    const [remarks, setRemarks] = useState('')
    const [error, setError] = useState({})
    const onChangeService = (e) => {
        if (e.target.checked && e.target.value !== '') {
            setService([...service, e.target.value])
        } else {
            setService(service.filter(val => val !== e.target.value))
        }
    }
    const onChangeProduct = (e) => {
        if (e.target.checked && e.target.value !== '') {
            setProduct([...product, e.target.value])
        } else {
            setProduct(product.filter(val => val !== e.target.value))
        }
    }
    const OnChangeGroupName = (e) => {
        setGroupName(e.target.value)
    }
    const OnChangeGroupNameKana = (e) => {
        setGroupNameKana(e.target.value)
    }
    const OnChangeRepFirstName = (e) => {
        setRepFirstName(e.target.value)
    }
    const OnChangeRepLastName = (e) => {
        setRepLastName(e.target.value)
    }
    const OnChangeRepFirstNameKana = (e) => {
        setRepFirstNameKana(e.target.value)
    }
    const OnChangeRepLastNameKana = (e) => {
        setRepLastNameKana(e.target.value)
    }
    const OnChangeDeptName = (e) => {
        setDeptName(e.target.value)
    }
    const OnChangeUserFirstName = (e) => {
        setUserFirstName(e.target.value)
    }
    const OnChangeUserLastName = (e) => {
        setUserLastName(e.target.value)
    }
    const OnChangeUserFirstNameKana = (e) => {
        setUserFirstNameKana(e.target.value)
    }
    const OnChangeUserLastNameKana = (e) => {
        setUserLastNameKana(e.target.value)
    }
    const OnChangeZip1 = (e) => {
        setZip1(e.target.value)
    }
    const OnChangeZip2 = (e) => {
        setZip2(e.target.value)
    }
    const OnChangePrefecture = (e) => {
        setPrefecture(e.target.value)
    }
    const OnChangeAddress1 = (e) => {
        setAddress1(e.target.value)
    }
    const OnChangeAddress2 = (e) => {
        setAddress2(e.target.value)
    }
    const OnChangePhone = (e) => {
        setPhone(e.target.value)
    }
    const OnChangeFax = (e) => {
        setFax(e.target.value)
    }
    const OnChangeContact = (e) => {
        setContact(e.target.value)
    }
    const OnChangeEmail = (e) => {
        setEmail(e.target.value)
    }
    const OnChangeContractStatus = (e) => {
        setContractStatus(e.target.value)
    }
    const OnChangeGroupSize = (e) => {
        setGroupSize(e.target.value)
    }
    const OnChangeRemarks = (e) => {
        setRemarks(e.target.value)
    }
    const removeSpaces = (value) => {
        return value.replace(' ', '').replace('　', '')
    }
    const handleChangeData = (event) => {
        if (event.target.type === 'checkbox') {
            if (event.target.checked) {
                setData({ ...data, [event.target.id]: event.target.value })
            } else {
                const { [event.target.id]: removedProp, ...newValues } = data
                setData(newValues)
            }
        } else if (event.target.type !== 'checkbox') {
            setData({ ...data, [event.target.name]: event.target.value })
        }
        setError((prevErrors) => ({
            ...prevErrors
        }))
    }
    const OnClickAutoZipCodeButton = async () => {
        const data = {
            contactZipcode1: zip1,
            contactZipcode2: zip2
        }
        await axios.post(`${CDP_API_URL}/getAddress-from-zipcode`, {
            ...data
        }, { headers: headers })
            .then(response => {
                response.data &&
                setPrefecture(response.data.prefecture)
                setAddress1((response.data.city + response.data.town).replace(' ', ''))
            })
            .catch(error => {
                console.error(error)
                alert('該当する郵便番号が検索できませんでした。')
            })
    }
    const submitButtonClick = () => {
        fetchDairitenData()
    }
    // ----Api Integration for Validation ------ //
    const fetchDairitenData = async () => {
        const inputData = {
            service: service,
            product: product,
            groupName: removeSpaces(groupName),
            groupNameKana: removeSpaces(groupNameKana),
            representativeFirstNameKanji: removeSpaces(repFirstName),
            representativeLastNameKanji: removeSpaces(repLastName),
            representativeFirstNameKana: removeSpaces(repFirstNameKana),
            representativeLastNameKana: removeSpaces(repLastNameKana),
            deptName: removeSpaces(deptName),
            userFirstNameKanji: removeSpaces(userFirstName),
            userLastNameKanji: removeSpaces(userLastName),
            userFirstNameKana: removeSpaces(userFirstNameKana),
            userLastNameKana: removeSpaces(userLastNameKana),
            zip1: zip1,
            zip2: zip2,
            prefecture: prefecture,
            address1: removeSpaces(address1),
            address2: removeSpaces(address2),
            phone: removeSpaces(phone),
            fax: fax,
            contact: contact,
            email: removeSpaces(email),
            contractStatus: contractStatus,
            groupSize: groupSize,
            remarks: remarks
        }
        try {
            const response = await fetch(`${CDP_API_URL}/pamphlet-validate-names`, {
                method: 'POST',
                headers: headers,
                body: JSON.stringify(inputData)
            })
            const data1 = await response.json()
            const newError = {}
            data1.systemMessages.forEach(item => {
                if (item.messageCode === 'datavalidated') {
                    navigate(`${CDP_PUBLIC_URL}/pamphlet/confirm`, { state: inputData })
                } else if (item.messageCode === 'SVC_10_400_41') {
                    newError.blankService = errorMessages.ifEmpty
                } else if (item.messageCode === 'SVC_10_400_42') {
                    newError.blankProduct = errorMessages.ifEmpty
                } else if (item.messageCode === 'SVC_10_400_44') {
                    newError.charLimitGroupNameKanji = errorMessages.charLimit50
                } else if (item.messageCode === 'SVC_10_400_45') {
                    newError.charNotValidGroupNameKanji = errorMessages.pamphletInvalidKanji
                } else if (item.messageCode === 'SVC_10_400_43') {
                    newError.blankGroupNameKanji = errorMessages.ifEmpty
                } else if (item.messageCode === 'SVC_10_400_47') {
                    newError.charLimitGroupNameKana = errorMessages.charLimit50
                } else if (item.messageCode === 'SVC_10_400_48') {
                    newError.charNotValidGroupNameKana = errorMessages.pamphletInvalidKana
                } else if (item.messageCode === 'SVC_10_400_46') {
                    newError.blankGroupNameKana = errorMessages.ifEmpty
                } else if (item.messageCode === 'SVC_10_400_50') {
                    newError.charLimitRepFirstNameKanji = errorMessages.charLimit30
                } else if (item.messageCode === 'SVC_10_400_51') {
                    newError.charNotValidRepFirstNameKanji = errorMessages.pamphletInvalidKanjiFirst
                } else if (item.messageCode === 'SVC_10_400_49') {
                    newError.blankRepFirstNameKanji = errorMessages.ifEmpty
                } else if (item.messageCode === 'SVC_10_400_53') {
                    newError.charLimitRepLastNameKanji = errorMessages.charLimit30
                } else if (item.messageCode === 'SVC_10_400_54') {
                    newError.charNotValidRepLastNameKanji = errorMessages.pamphletInvalidKanjiLast
                } else if (item.messageCode === 'SVC_10_400_52') {
                    newError.blankRepLastNameKanji = errorMessages.ifEmpty
                } else if (item.messageCode === 'SVC_10_400_56') {
                    newError.charLimitRepFirstNameKana = errorMessages.charLimit30
                } else if (item.messageCode === 'SVC_10_400_57') {
                    newError.charNotValidRepFirstNameKana = errorMessages.pamphletInvalidKanaFirst
                } else if (item.messageCode === 'SVC_10_400_55') {
                    newError.blankRepFirstNameKana = errorMessages.ifEmpty
                } else if (item.messageCode === 'SVC_10_400_59') {
                    newError.charLimitRepLastNameKana = errorMessages.charLimit30
                } else if (item.messageCode === 'SVC_10_400_60') {
                    newError.charNotValidRepLastNameKana = errorMessages.pamphletInvalidKanaLast
                } else if (item.messageCode === 'SVC_10_400_58') {
                    newError.blankRepLastNameKana = errorMessages.ifEmpty
                } else if (item.messageCode === 'SVC_10_400_65') {
                    newError.charLimitUserFirstNameKanji = errorMessages.charLimit30
                } else if (item.messageCode === 'SVC_10_400_66') {
                    newError.charNotValidUserFirstNameKanji = errorMessages.pamphletInvalidKanjiFirst
                } else if (item.messageCode === 'SVC_10_400_64') {
                    newError.blankUserFirstNameKanji = errorMessages.ifEmpty
                } else if (item.messageCode === 'SVC_10_400_68') {
                    newError.charLimitUserLastNameKanji = errorMessages.charLimit30
                } else if (item.messageCode === 'SVC_10_400_69') {
                    newError.charNotValidUserLastNameKanji = errorMessages.pamphletInvalidKanjiLast
                } else if (item.messageCode === 'SVC_10_400_67') {
                    newError.blankUserLastNameKanji = errorMessages.ifEmpty
                } else if (item.messageCode === 'SVC_10_400_71') {
                    newError.charLimitUserFirstNameKana = errorMessages.charLimit30
                } else if (item.messageCode === 'SVC_10_400_72') {
                    newError.charNotValidUserFirstNameKana = errorMessages.pamphletInvalidKanaFirst
                } else if (item.messageCode === 'SVC_10_400_70') {
                    newError.blankUserFirstNameKana = errorMessages.ifEmpty
                } else if (item.messageCode === 'SVC_10_400_74') {
                    newError.charLimitUserLastNameKana = errorMessages.charLimit30
                } else if (item.messageCode === 'SVC_10_400_75') {
                    newError.charNotValidUserLastNameKana = errorMessages.pamphletInvalidKanaLast
                } else if (item.messageCode === 'SVC_10_400_73') {
                    newError.blankUserLastNameKana = errorMessages.ifEmpty
                } else if (item.messageCode === 'SVC_10_400_62') {
                    newError.charLimitDeptName = errorMessages.charLimit50
                } else if (item.messageCode === 'SVC_10_400_63') {
                    newError.charNotValidDeptName = errorMessages.pamphletInvalidKanji
                } else if (item.messageCode === 'SVC_10_400_61') {
                    newError.blankDeptName = errorMessages.ifEmpty
                } else if (item.messageCode === 'SVC_10_400_78') {
                    newError.charLimitZip1 = errorMessages.charLimit3
                } else if (item.messageCode === 'SVC_10_400_79') {
                    newError.charLimitZip2 = errorMessages.charLimit4
                } else if (item.messageCode === 'SVC_10_400_80') {
                    newError.charNotValidZip = errorMessages.invalidInput
                } else if (item.messageCode === 'SVC_10_400_81') {
                    newError.charNotValidZip = errorMessages.invalidInput
                } else if (item.messageCode === 'SVC_10_400_76') {
                    newError.blankZip1 = errorMessages.ifEmpty
                } else if (item.messageCode === 'SVC_10_400_77') {
                    newError.blankZip2 = errorMessages.ifEmpty
                } else if (item.messageCode === 'SVC_10_400_82') {
                    newError.blankPrefecture = errorMessages.ifEmpty
                } else if (item.messageCode === 'SVC_10_400_84') {
                    newError.charLimitAddress1 = errorMessages.charLimit60
                } else if (item.messageCode === 'SVC_10_400_87') {
                    newError.charLimitAddress2 = errorMessages.charLimit60
                } else if (item.messageCode === 'SVC_10_400_85') {
                    newError.charNotValidAddress = errorMessages.pamphletInvalidKanji
                } else if (item.messageCode === 'SVC_10_400_88') {
                    newError.charNotValidAddress = errorMessages.pamphletInvalidKanji
                } else if (item.messageCode === 'SVC_10_400_83') {
                    newError.blankAddress1 = errorMessages.ifEmpty
                } else if (item.messageCode === 'SVC_10_400_86') {
                    newError.blankAddress2 = errorMessages.ifEmpty
                } else if (item.messageCode === 'SVC_10_400_89') {
                    newError.blankPhone = errorMessages.ifEmpty
                } else if (item.messageCode === 'SVC_10_400_90') {
                    newError.charLimitPhone = errorMessages.charLimit13
                } else if (item.messageCode === 'SVC_10_400_91') {
                    newError.charNotValidPhone = errorMessages.invalidInput
                } else if (item.messageCode === 'SVC_10_400_92') {
                    newError.charLimitFax = errorMessages.charLimit13
                } else if (item.messageCode === 'SVC_10_400_93') {
                    newError.charNotValidFax = errorMessages.invalidInput
                } else if (item.messageCode === 'SVC_10_400_94') {
                    newError.blankEmail = errorMessages.ifEmpty
                } else if (item.messageCode === 'SVC_10_400_96') {
                    newError.isNotEmail = errorMessages.invalidInput
                } else if (item.messageCode === 'SVC_10_400_97') {
                    newError.isNotEmail = errorMessages.invalidInput
                } else if (item.messageCode === 'SVC_10_400_95') {
                    newError.charLimitEmail = errorMessages.charLimit50
                } else if (item.messageCode === 'SVC_10_400_99') {
                    newError.blankContact = errorMessages.ifEmpty
                } else if (item.messageCode === 'SVC_10_400_98') {
                    newError.charLimitRemarks = errorMessages.charLimit500
                }
            })
            setError(newError)
            window.scrollTo(0, 0)
        } catch (error) {
            alert('送信エラーが発生しました')
        }
    }
    useEffect(() => {
        if (confirmData) {
            setData(confirmData.data)
            setService(confirmData.service)
            setProduct(confirmData.product)
            setGroupName(confirmData.groupName)
            setGroupNameKana(confirmData.groupNameKana)
            setRepFirstName(confirmData.representativeFirstNameKanji)
            setRepLastName(confirmData.representativeLastNameKanji)
            setRepFirstNameKana(confirmData.representativeFirstNameKana)
            setRepLastNameKana(confirmData.representativeLastNameKana)
            setDeptName(confirmData.deptName)
            setUserFirstName(confirmData.userFirstNameKanji)
            setUserLastName(confirmData.userLastNameKanji)
            setUserFirstNameKana(confirmData.userFirstNameKana)
            setUserLastNameKana(confirmData.userLastNameKana)
            setZip1(confirmData.zip1)
            setZip2(confirmData.zip2)
            setPrefecture(confirmData.prefecture)
            setAddress1(confirmData.address1)
            setAddress2(confirmData.address2)
            setPhone(confirmData.phone)
            setFax(confirmData.fax)
            setContact(confirmData.contact)
            setEmail(confirmData.email)
            setContractStatus(confirmData.contractStatus)
            setGroupSize(confirmData.groupSize)
            setRemarks(confirmData.remarks)
            window.history.replaceState({}, confirmData)
        }
    }, [])
    return (
        <div className="dairiten-input-section-inputdetails row">
            <div className="col-sm-12 col-md-12 col-lg-12">
            <div className="">
                <h2 id="h2" style={{ fontSize: 'large' }}>資料請求・相談サービスのお申し込み</h2>
                <p style={{ fontSize: 'larger' }}>こちらは、団体保険専用のページです。</p>
                <p style={{ fontSize: 'larger' }}>個人保険については<a href='http://www.metlife.co.jp/products/' style={{ color: '#007cc2', textDecoration: 'underline' }}>別ページ</a>よりお問い合わせください。</p>
                <div className="card-container-inputdetails">
                    <div className="row">
                        <span id="span1">ご希望のサービスを選択ください（複数選択可）</span>
                        <div className="col-lg-3 col-md-3 col-sm-12 col-12 titleDiv">
                            <label htmlFor="inputtext" className="col-form-label l1">サービス（無料）</label><span className="required">必須</span>
                        </div>
                        <div className="col-lg-9 col-md-9 col-sm-12 col-12 contentDiv">
                            <div className="row" value={service} onClick={handleChangeData} onChange={(e) => onChangeService(e)}>
                                <div className='checkboxWrap col-lg-3 col-md-3 col-sm-3 col-3'><input type="checkbox" checked={confirmData && service.indexOf('資料請求') > -1} value="資料請求" />
                                    &nbsp;&nbsp;資料請求</div>
                                <div className='checkboxWrap col-lg-9 col-md-9 col-sm-9 col-9'>選択された商品パンフレットを送付します。</div>
                                <div className='checkboxWrap col-lg-3 col-md-3 col-sm-3 col-3'><input type="checkbox" checked={confirmData && service.indexOf('対面でのご相談') > -1} value="対面でのご相談" />
                                    &nbsp;&nbsp;対面でのご相談</div>
                                <div className='checkboxWrap col-lg-9 col-md-9 col-sm-9 col-9'>ご相談内容に応じて、資料の説明やプランのご提案をします。</div>
                                <div className='checkboxWrap col-12'><input type="checkbox" checked={confirmData && service.indexOf('オンラインでのご相談') > -1} value='オンラインでのご相談' />
                                    &nbsp;&nbsp;オンラインでのご相談</div>
                            </div>
                            <div className="errDisplayArea">
                                <InputScreenErrorMessage errorMessage={error.blankService}></InputScreenErrorMessage>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="card-container-inputdetails">
                    <div className="row">
                        <span id="span1">ご希望の保険をお選びください（複数選択可）</span>
                        <div className="col-lg-3 col-md-3 col-sm-12 col-12 titleDiv">
                            <label htmlFor="inputtext" className="col-form-label l1">商品名&nbsp;&nbsp;</label><span className="required">必須</span>
                        </div>
                        <div className="col-lg-9 col-md-9 col-sm-12 col-12 contentDiv">
                            <div className="row" value={product} onClick={handleChangeData} onChange={(e) => onChangeProduct(e)}>
                                <div className='checkboxWrap col-12'><input type="checkbox" checked={confirmData && product.indexOf('無配当総合福祉団体定期保険（ノンパーグループ保険）') > -1} value='無配当総合福祉団体定期保険（ノンパーグループ保険）' />
                                    &nbsp;&nbsp;無配当総合福祉団体定期保険（ノンパーグループ保険）</div>
                                <div className='checkboxWrap col-12'><input type="checkbox" checked={confirmData && product.indexOf('総合福祉団体定期保険') > -1} value='総合福祉団体定期保険' />
                                    &nbsp;&nbsp;総合福祉団体定期保険</div>
                                <div className='checkboxWrap col-12'><input type="checkbox" checked={confirmData && product.indexOf('新医療保障保険（団体型）（グループメディカルBasic+）') > -1} value='新医療保障保険（団体型）（グループメディカルBasic+）' />
                                    &nbsp;&nbsp;新医療保障保険（団体型）（グループメディカルBasic+）</div>
                                <div className='checkboxWrap col-12'><input type="checkbox" checked={confirmData && product.indexOf('団体定期保険（S51）（Bグループ保険）') > -1} value='団体定期保険（S51）（Bグループ保険）' />
                                    &nbsp;&nbsp;団体定期保険（S51）（Bグループ保険）</div>
                            </div>
                            <div className="errDisplayArea">
                                <InputScreenErrorMessage errorMessage={error.blankProduct}></InputScreenErrorMessage>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="card-container-inputdetails">
                    <div className="row">
                        <span id="span1">お客さまの情報について</span>
                        <div className="col-lg-3 col-md-3 col-sm-12 col-12 titleDiv">
                            <label htmlFor="inputtext" className="col-form-label l1">団体名&nbsp;&nbsp;</label><span className="required">必須</span>
                        </div>
                        <div className="col-lg-9 col-md-9 col-sm-12 col-12 contentDiv">
                            <span className="note">（全角でご入力ください　例：株式会社保険商事）</span><br></br>
                            <input type="text" id="text12" onChange={OnChangeGroupName} value={groupName} />
                            <div className="errDisplayArea">
                                <InputScreenErrorMessage errorMessage={error.charLimitGroupNameKanji}></InputScreenErrorMessage>
                                <InputScreenErrorMessage errorMessage={error.charNotValidGroupNameKanji}></InputScreenErrorMessage>
                                <InputScreenErrorMessage errorMessage={error.blankGroupNameKanji}></InputScreenErrorMessage>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-3 col-sm-12 col-12 titleDiv">
                            <label htmlFor="inputtext" className="col-form-label l1">団体名&nbsp;&nbsp;　フリガナ</label><span className="required">必須</span>
                        </div>
                        <div className="col-lg-9 col-md-9 col-sm-12 col-12 contentDiv">
                            <span className="note">（全角でご入力ください　例：カブシキガイシャホケンショウジ）</span><br></br>
                            <input type="text" id="text12" onChange={OnChangeGroupNameKana} value={groupNameKana} />
                            <div className="errDisplayArea">
                                <InputScreenErrorMessage errorMessage={error.charLimitGroupNameKana}></InputScreenErrorMessage>
                                <InputScreenErrorMessage errorMessage={error.charNotValidGroupNameKana}></InputScreenErrorMessage>
                                <InputScreenErrorMessage errorMessage={error.blankGroupNameKana}></InputScreenErrorMessage>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-3 col-sm-12 col-12 titleDiv">
                            <label htmlFor="inputtext" className="col-form-label l1">代表者名&nbsp;&nbsp;</label><span className="required">必須</span>
                        </div>
                        <div className="col-lg-9 col-md-9 col-sm-12 col-12 contentDiv row" style={{ padding: '15px 0px' }}>
                            <span className="note">（全角でご入力ください　例：保険　太郎）</span><br></br>
                            <div className="col-lg-6 col-md-6 col-sm-12"><span htmlFor="inputtext"><label>姓&nbsp;&nbsp;</label></span><input className="col-10" type="text" onChange={OnChangeRepLastName} value={repLastName} /></div>
                            <div className="col-lg-6 col-md-6 col-sm-12"><span htmlFor="inputtext"><label>名&nbsp;&nbsp;</label></span><input className="col-10" type="text" onChange={OnChangeRepFirstName} value={repFirstName} /></div>
                            <div className="errDisplayArea">
                                <InputScreenErrorMessage errorMessage={error.charLimitRepFirstNameKanji}></InputScreenErrorMessage>
                                <InputScreenErrorMessage errorMessage={error.charNotValidRepFirstNameKanji}></InputScreenErrorMessage>
                                <InputScreenErrorMessage errorMessage={error.blankRepFirstNameKanji}></InputScreenErrorMessage>
                                <InputScreenErrorMessage errorMessage={error.charLimitRepLastNameKanji}></InputScreenErrorMessage>
                                <InputScreenErrorMessage errorMessage={error.charNotValidRepLastNameKanji}></InputScreenErrorMessage>
                                <InputScreenErrorMessage errorMessage={error.blankRepLastNameKanji}></InputScreenErrorMessage>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-3 col-sm-12 col-12 titleDiv">
                            <label htmlFor="inputtext" className="col-form-label l1">代表者名&nbsp;&nbsp;　フリガナ</label><span className="required">必須</span>
                        </div>
                        <div className="col-lg-9 col-md-9 col-sm-12 col-12 contentDiv row" style={{ padding: '15px 0px' }}>
                            <span className="note">（全角でご入力ください　例：ホケン　タロウ）</span><br></br>
                            <div className="col-lg-6 col-md-6 col-sm-12"><span htmlFor="inputtext"><label>姓&nbsp;&nbsp;</label></span><input className="col-10" type="text" onChange={OnChangeRepLastNameKana} value={repLastNameKana} /></div>
                            <div className="col-lg-6 col-md-6 col-sm-12"><span htmlFor="inputtext"><label>名&nbsp;&nbsp;</label></span><input className="col-10" type="text" onChange={OnChangeRepFirstNameKana} value={repFirstNameKana} /></div>
                            <div className="errDisplayArea">
                                <InputScreenErrorMessage errorMessage={error.charLimitRepFirstNameKana}></InputScreenErrorMessage>
                                <InputScreenErrorMessage errorMessage={error.charNotValidRepFirstNameKana}></InputScreenErrorMessage>
                                <InputScreenErrorMessage errorMessage={error.blankRepFirstNameKana}></InputScreenErrorMessage>
                                <InputScreenErrorMessage errorMessage={error.charLimitRepLastNameKana}></InputScreenErrorMessage>
                                <InputScreenErrorMessage errorMessage={error.charNotValidRepLastNameKana}></InputScreenErrorMessage>
                                <InputScreenErrorMessage errorMessage={error.blankRepLastNameKana}></InputScreenErrorMessage>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-3 col-sm-12 col-12 titleDiv">
                            <label htmlFor="inputtext" className="col-form-label l1">ご担当者部署名&nbsp;&nbsp;</label><span className="required">必須</span>
                        </div>
                        <div className="col-lg-9 col-md-9 col-sm-12 col-12 contentDiv">
                            <span className="note">（全角でご入力ください　例：人事部）</span><br></br>
                            <input type="text" id="text12" onChange={OnChangeDeptName} value={deptName} />
                            <div className="errDisplayArea">
                                <InputScreenErrorMessage errorMessage={error.charLimitDeptName}></InputScreenErrorMessage>
                                <InputScreenErrorMessage errorMessage={error.charNotValidDeptName}></InputScreenErrorMessage>
                                <InputScreenErrorMessage errorMessage={error.blankDeptName}></InputScreenErrorMessage>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-3 col-sm-12 col-12 titleDiv">
                            <label htmlFor="inputtext" className="col-form-label l1">ご担当者名&nbsp;&nbsp;</label><span className="required">必須</span>
                        </div>
                        <div className="col-lg-9 col-md-9 col-sm-12 col-12 contentDiv row" style={{ padding: '15px 0px' }}>
                            <span className="note">（全角でご入力ください　例：保険　太郎）</span><br></br>
                            <div className="col-lg-6 col-md-6 col-sm-12"><span htmlFor="inputtext"><label>姓&nbsp;&nbsp;</label></span><input className="col-10" type="text" onChange={OnChangeUserLastName} value={userLastName} /></div>
                            <div className="col-lg-6 col-md-6 col-sm-12"><span htmlFor="inputtext"><label>名&nbsp;&nbsp;</label></span><input className="col-10" type="text" onChange={OnChangeUserFirstName} value={userFirstName} /></div>
                            <div className="errDisplayArea">
                                <InputScreenErrorMessage errorMessage={error.charLimitUserFirstNameKanji}></InputScreenErrorMessage>
                                <InputScreenErrorMessage errorMessage={error.charNotValidUserFirstNameKanji}></InputScreenErrorMessage>
                                <InputScreenErrorMessage errorMessage={error.blankUserFirstNameKanji}></InputScreenErrorMessage>
                                <InputScreenErrorMessage errorMessage={error.charLimitUserLastNameKanji}></InputScreenErrorMessage>
                                <InputScreenErrorMessage errorMessage={error.charNotValidUserLastNameKanji}></InputScreenErrorMessage>
                                <InputScreenErrorMessage errorMessage={error.blankUserLastNameKanji}></InputScreenErrorMessage>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-3 col-sm-12 col-12 titleDiv">
                            <label htmlFor="inputtext" className="col-form-label l1">ご担当者名&nbsp;&nbsp;　フリガナ</label><span className="required">必須</span>
                        </div>
                        <div className="col-lg-9 col-md-9 col-sm-12 col-12 contentDiv row" style={{ padding: '15px 0px' }}>
                            <span className="note">（全角でご入力ください　例：ホケン　タロウ）</span><br></br>
                            <div className="col-lg-6 col-md-6 col-sm-12"><span htmlFor="inputtext"><label>姓&nbsp;&nbsp;</label></span><input className="col-10" type="text" onChange={OnChangeUserLastNameKana} value={userLastNameKana} /></div>
                            <div className="col-lg-6 col-md-6 col-sm-12"><span htmlFor="inputtext"><label>名&nbsp;&nbsp;</label></span><input className="col-10" type="text" onChange={OnChangeUserFirstNameKana} value={userFirstNameKana} /></div>
                            <div className="errDisplayArea">
                                <InputScreenErrorMessage errorMessage={error.charLimitUserFirstNameKana}></InputScreenErrorMessage>
                                <InputScreenErrorMessage errorMessage={error.charNotValidUserFirstNameKana}></InputScreenErrorMessage>
                                <InputScreenErrorMessage errorMessage={error.blankUserFirstNameKana}></InputScreenErrorMessage>
                                <InputScreenErrorMessage errorMessage={error.charLimitUserLastNameKana}></InputScreenErrorMessage>
                                <InputScreenErrorMessage errorMessage={error.charNotValidUserLastNameKana}></InputScreenErrorMessage>
                                <InputScreenErrorMessage errorMessage={error.blankUserLastNameKana}></InputScreenErrorMessage>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-3 col-sm-12 col-12 titleDiv">
                            <label htmlFor="inputtext" className="col-form-label l1">ご住所</label><span className="required">必須</span>
                        </div>
                        <div className="col-lg-9 col-md-9 col-sm-12 col-12 contentDiv">
                            <span className="note">（半角数字でご入力ください。例：123-4567）</span><br></br>
                            <span htmlFor="inputtext"><label>〒&nbsp;</label></span><input type="text" id='text1' maxLength={3} onChange={OnChangeZip1} value={zip1} /><span>-</span>
                            <input type="text" id='text1' maxLength={4} onChange={OnChangeZip2} value={zip2} />
                            <button type="button" id='button' onClick={OnClickAutoZipCodeButton}>検索</button><br></br>
                            <div className="errDisplayArea">
                                <InputScreenErrorMessage errorMessage={error.blankZip1}></InputScreenErrorMessage>
                                <InputScreenErrorMessage errorMessage={error.blankZip2}></InputScreenErrorMessage>
                                <InputScreenErrorMessage errorMessage={error.charLimitZip1}></InputScreenErrorMessage>
                                <InputScreenErrorMessage errorMessage={error.charLimitZip2}></InputScreenErrorMessage>
                                <InputScreenErrorMessage errorMessage={error.charNotValidZip}></InputScreenErrorMessage>
                            </div>
                            <span className="note">都道府県</span><br></br>
                            <select className="132_DATA" id="pref" onChange={OnChangePrefecture} value={prefecture} style={{ height: '25px', marginBottom: '15px' }}>
                                <option value="">都道府県</option>
                                <optgroup label="北海道・東北">
                                    <option value="北海道">北海道</option>
                                    <option value="青森県">青森県</option>
                                    <option value="岩手県">岩手県</option>
                                    <option value="秋田県">秋田県</option>
                                    <option value="宮城県">宮城県</option>
                                    <option value="山形県">山形県</option>
                                    <option value="福島県">福島県</option>
                                </optgroup>
                                <optgroup label="関東">
                                    <option value="東京都">東京都</option>
                                    <option value="神奈川県">神奈川県</option>
                                    <option value="埼玉県">埼玉県</option>
                                    <option value="千葉県">千葉県</option>
                                    <option value="茨城県">茨城県</option>
                                    <option value="栃木県">栃木県</option>
                                    <option value="群馬県">群馬県</option>
                                </optgroup>
                                <optgroup label="甲信越・北陸">
                                    <option value="新潟県">新潟県</option>
                                    <option value="富山県">富山県</option>
                                    <option value="石川県">石川県</option>
                                    <option value="福井県">福井県</option>
                                    <option value="山梨県">山梨県</option>
                                    <option value="長野県">長野県</option>
                                </optgroup>
                                <optgroup label="東海">
                                    <option value="岐阜県">岐阜県</option>
                                    <option value="静岡県">静岡県</option>
                                    <option value="愛知県">愛知県</option>
                                    <option value="三重県">三重県</option>
                                </optgroup>
                                <optgroup label="近畿">
                                    <option value="滋賀県">滋賀県</option>
                                    <option value="京都府">京都府</option>
                                    <option value="大阪府">大阪府</option>
                                    <option value="兵庫県">兵庫県</option>
                                    <option value="奈良県">奈良県</option>
                                    <option value="和歌山県">和歌山県</option>
                                </optgroup>
                                <optgroup label="中国">
                                    <option value="鳥取県">鳥取県</option>
                                    <option value="島根県">島根県</option>
                                    <option value="岡山県">岡山県</option>
                                    <option value="広島県">広島県</option>
                                    <option value="山口県">山口県</option>
                                </optgroup>
                                <optgroup label="四国">
                                    <option value="徳島県">徳島県</option>
                                    <option value="香川県">香川県</option>
                                    <option value="愛媛県">愛媛県</option>
                                    <option value="高知県">高知県</option>
                                </optgroup>
                                <optgroup label="九州・沖縄">
                                    <option value="福岡県">福岡県</option>
                                    <option value="佐賀県">佐賀県</option>
                                    <option value="長崎県">長崎県</option>
                                    <option value="熊本県">熊本県</option>
                                    <option value="大分県">大分県</option>
                                    <option value="宮崎県">宮崎県</option>
                                    <option value="鹿児島県">鹿児島県</option>
                                    <option value="沖縄県">沖縄県</option>
                                </optgroup>
                            </select><br></br>
                            <span className="note">市区町村・群　（全角でご入力ください　例：墨田区太平）</span><br></br>
                            <input type="text" className="inputSpace1" onChange={OnChangeAddress1} value={address1} /><br></br>
                            <div className="errDisplayArea">
                                <InputScreenErrorMessage errorMessage={error.charLimitAddress1}></InputScreenErrorMessage>
                                <InputScreenErrorMessage errorMessage={error.blankAddress1}></InputScreenErrorMessage>
                            </div>
                            <span className="note">番地・マンション・建物名&nbsp;&nbsp;　（全角でご入力ください　例：４－１－３セイホビル３階）</span><br></br>
                            <input type="text" className="inputSpace1" onChange={OnChangeAddress2} value={address2} />
                            <div className="errDisplayArea">
                                <InputScreenErrorMessage errorMessage={error.charLimitAddress2}></InputScreenErrorMessage>
                                <InputScreenErrorMessage errorMessage={error.blankAddress2}></InputScreenErrorMessage>
                                <InputScreenErrorMessage errorMessage={error.charNotValidAddress}></InputScreenErrorMessage>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-3 col-sm-12 col-12 titleDiv">
                            <label htmlFor="inputtext" className="col-form-label l1">電話番号</label><span className="required">必須</span>
                        </div>
                        <div className="col-lg-9 col-md-9 col-sm-12 col-12 contentDiv">
                            <div className="">
                                <span className="note">（半角でご入力ください　例：03-1234-5678）</span><br></br>
                                <input type="text" onChange={OnChangePhone} value={phone} />
                                <div className="errDisplayArea">
                                    <InputScreenErrorMessage errorMessage={error.blankPhone}></InputScreenErrorMessage>
                                    <InputScreenErrorMessage errorMessage={error.charLimitPhone}></InputScreenErrorMessage>
                                    <InputScreenErrorMessage errorMessage={error.charNotValidPhone}></InputScreenErrorMessage>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-3 col-sm-12 col-12 titleDiv">
                            <label htmlFor="inputtext" className="col-form-label l1">FAX番号</label>
                        </div>
                        <div className="col-lg-9 col-md-9 col-sm-12 col-12 contentDiv">
                            <div className="">
                                <span className="note">（半角でご入力ください　例：03-1234-5678）</span><br></br>
                                <input type="text" onChange={OnChangeFax} value={fax} />
                                <div className="errDisplayArea">
                                    <InputScreenErrorMessage errorMessage={error.blankFax}></InputScreenErrorMessage>
                                    <InputScreenErrorMessage errorMessage={error.charLimitFax}></InputScreenErrorMessage>
                                    <InputScreenErrorMessage errorMessage={error.charNotValidFax}></InputScreenErrorMessage>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-3 col-sm-12 col-12 titleDiv">
                            <label htmlFor="inputtext" className="col-form-label l1">ご希望の連絡方法</label><span className="required">必須</span>
                        </div>
                        <div className="col-lg-9 col-md-9 col-sm-12 col-12 contentDiv">
                            <div className="row" value={contact} onChange={(e) => OnChangeContact(e)}>
                                <div className='checkboxWrap col-lg-4 col-md-4 col-sm-12 col-12'><input type='radio' name='contact' checked={contact === 'メール'} value='メール' />&nbsp;&nbsp;メール</div>
                                <div className='checkboxWrap col-lg-4 col-md-4 col-sm-12 col-12'><input type='radio' name='contact' checked={contact === '電話'} value='電話' />&nbsp;&nbsp;電話</div>
                            </div>
                            <span className="note">（メールをご希望の場合はメールアドレスを半角英数字でご入力ください　例：abcd@abcd.co.jp）</span><br></br>
                            <input name="tel" type="text" className='inputSpace1' id='email' size="20" onChange={OnChangeEmail} value={email}></input>
                            <div className="errDisplayArea">
                                <InputScreenErrorMessage errorMessage={error.blankEmail}></InputScreenErrorMessage>
                                <InputScreenErrorMessage errorMessage={error.isNotEmail}></InputScreenErrorMessage>
                                <InputScreenErrorMessage errorMessage={error.charLimitEmail}></InputScreenErrorMessage>
                                <InputScreenErrorMessage errorMessage={error.blankContact}></InputScreenErrorMessage>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-3 col-sm-12 col-12 titleDiv">
                            <label htmlFor="inputtext" className="col-form-label l1">現在のご加入契約</label>
                        </div>
                        <div className="col-lg-9 col-md-9 col-sm-12 col-12 contentDiv">
                            <div className="row" value={contractStatus} onChange={(e) => OnChangeContractStatus(e)}>
                                <div className='checkboxWrap col-lg-4 col-md-4 col-sm-12 col-12'><input type='radio' name='contractStatus' checked={contractStatus === 'メットライフ生命に加入'} value='メットライフ生命に加入' />&nbsp;&nbsp;メットライフ生命に加入</div>
                                <div className='checkboxWrap col-lg-5 col-md-5 col-sm-12 col-12'><input type='radio' name='contractStatus' checked={contractStatus === 'メットライフ生命以外に加入'} value='メットライフ生命以外に加入' />&nbsp;&nbsp;メットライフ生命以外に加入</div>
                                <div className='checkboxWrap col-lg-3 col-md-3 col-sm-12 col-12'><input type='radio' name='contractStatus' checked={contractStatus === '加入していない'} value='加入していない' />&nbsp;&nbsp;加入していない</div>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-3 col-sm-12 col-12 titleDiv">
                            <label htmlFor="inputtext" className="col-form-label l1">団体総人数</label>
                        </div>
                        <div className="col-lg-9 col-md-9 col-sm-12 col-12 contentDiv">
                            <div className="row" value={groupSize} onChange={(e) => OnChangeGroupSize(e)}>
                                <div className='checkboxWrap col-lg-3 col-md-3 col-sm-6 col-6'><input type='radio' name='groupSize' checked={groupSize === '～24名'} value='～24名' />&nbsp;&nbsp;～24名</div>
                                <div className='checkboxWrap col-lg-3 col-md-3 col-sm-6 col-6'><input type='radio' name='groupSize' checked={groupSize === '25名～99名'} value='25名～99名' />&nbsp;&nbsp;25名～99名</div>
                                <div className='checkboxWrap col-lg-3 col-md-3 col-sm-6 col-6'><input type='radio' name='groupSize' checked={groupSize === '100名～299名'} value='100名～299名' />&nbsp;&nbsp;100名～299名</div>
                                <div className='checkboxWrap col-lg-3 col-md-3 col-sm-6 col-6'><input type='radio' name='groupSize' checked={groupSize === '300名～'} value='300名～' />&nbsp;&nbsp;300名～</div>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-3 col-sm-12 col-12 titleDiv">
                            <label htmlFor="inputtext" className="col-form-label l1">（ご相談をご希望の場合）
                            <br></br>ご相談内容をご記入ください。</label>
                        </div>
                        <div className="col-lg-9 col-md-9 col-sm-12 col-12 contentDiv">
                            <span className="note">500文字以内でご入力ください。</span><br></br>
                            <textarea name="010_DATA" rows="5" cols="60" id="detail" onChange={OnChangeRemarks} value={remarks}></textarea>
                        </div>
                        <div className="errDisplayArea">
                            <InputScreenErrorMessage errorMessage={error.charLimitRemarks}></InputScreenErrorMessage>
                        </div>
                    </div>
                </div>
            </div>
            <div className="">
                <div className="cardContainer row">
                    <span id="spans">・選択される商品や引受形態などにより当社でのお引き受けができない場合がございます。あらかじめご了承ください。</span><br></br>
                    <span id="spans">・ご依頼の地域によってはお伺いできない場合がございますので、あらかじめご了承ください。</span><br></br>
                    <span id="spans">・当社の契約に加入されているお客さまにつきましては、現在の契約の担当者よりご連絡を差し上げる場合がございます。</span>
                </div>
                <div className="sslBoxWrapper">
                    <p>ご入力いただきました個人情報は、ご請求いただいた資料の送付、メールや郵送、電話などによる当社の商品・サービスのご案内に使用します。</p>
                    <div className="sslBox">
                    <p style={{ padding: 'unset' }}>当サイトはお客さまの個人情報を安全に送受信するために128bit版SSL（暗号化通信）を使用しております。<br></br>
                      <a href="http://www.metlife.co.jp/about/governance/ev-ssl/#h2Area03" target="_blank" rel="noreferrer noopener" className="popupLink-01" style={{ color: '#007cc2', textDecoration: 'underline' }}>詳細はこちらをご覧ください。</a></p>
                  </div>
                </div>
            </div>
            <div className="">
                <br></br>
                <div id="align"><p>上記にご同意いただける場合は、「確認」ボタンを押し、入力内容の確認へお進みください。</p>
                <p className="form-btn-01"><input type="submit" value="確認" name="submit" className="btn-submit" onClick={submitButtonClick} /></p>
                </div>
                <p className="guard_mhp">{PamphletPageNumber}</p>
            </div>
            </div>
        </div>
    )
}

export default PamphletRequestForm
